<template>
  <div class="the-navbar__user-meta flex items-center">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user.name }}</p>
      <small>Available</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <feather-icon icon="UserIcon" svgClasses="w-8 h-8" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span @click="profile" class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {

  data() {
    return {
      user: {
        name: "",
      },
    }
  },
  computed: {
    activeUserInfo () {
      return JSON.parse(localStorage.currentUser)
    },
    isLogged () {
      return this.$store.state.isLoggedIn
    },
  },
  beforeMount() {
    this.loadUser()
  },
  methods: {
    logout () {
      localStorage.removeItem('userInfo')
      delete localStorage.token
      delete localStorage.currentUser
      this.$router.push('/pages/login').catch(() => {})
    },

    profile () {
      this.$router.push('/profile')
    },

    loadUser() {
      this.user = JSON.parse(localStorage.currentUser)
    },

  }
}
</script>
